import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Select from '@react/react-spectrum/Select'
import Textfield from '@react/react-spectrum/Textfield'
import JsonViewer from 'components/JsonViewer'
import Radio from '@react/react-spectrum/Radio'
import RadioGroup from '@react/react-spectrum/RadioGroup'

const Events = ({ screen, disabled, onScreenUpdate }) => {
  const screenEvents = [
    { label: 'Product View', value: 'commerce.productViews' },
    { label: 'Category View', value: 'commerce.categoryViews' },
    { label: 'Custom Event', value: 'customEvent' },
    { label: ' --- ', value: '' },
  ]
  return (
    <div>
      <FieldLabel label='Screen opened' labelFor='screen-sidebar-event'>
        <Select
          aria-label='Screen Event Type'
          options={screenEvents}
          value={screen.meta.event || ''}
          id='screen-sidebar-event'
          menuClassName={'ScreenSidebar__dropdownList'}
          onChange={onScreenUpdate('event')}
          disabled={disabled}
        />
      </FieldLabel>
      {screen?.meta?.event == 'customEvent' && (
        <FieldLabel label='Custom Event'>
          <Textfield
            placeholder='Custom Event'
            name='customEvent'
            label='Custom Event'
            value={screen?.meta?.customEvent || ''}
            onChange={onScreenUpdate('customEvent')}
          />
        </FieldLabel>
      )}
    </div>
  )
}

const Personalization = ({ screen, disabled, onScreenUpdate, project }) => {
  const [method, setMethod] = React.useState(() => getPersonalizationMethod(screen))
  const isMobileV2 = project?.meta?.type === 'mobile-v2'

  const onMethodChange = (value) => {
    onScreenUpdate('parsonalizationMethod')(value)
    setMethod(value)
  }

  const radioOptions = [
    { label: 'None', value: 'none' },
    { label: 'Adobe Target', value: 'target' },
  ]

  if (!isMobileV2) {
    radioOptions.push({ label: 'AJO Code-Based Experience', value: 'ajo' })
  }

  return (
    <>
      <FieldLabel label='Method'>
        <RadioGroup onChange={onMethodChange} selectedValue={method} vertical>
          {radioOptions.map((option) => (
            <Radio key={option.value} value={option.value}>
              {option.label}
            </Radio>
          ))}
        </RadioGroup>
      </FieldLabel>

      {method === 'target' && (
        <FieldLabel label='mBox name'>
          <Textfield
            placeholder=''
            name='mboxName'
            value={screen.meta.mboxName || ''}
            onChange={onScreenUpdate('mboxName')}
            disabled={disabled}
          />
        </FieldLabel>
      )}

      {method === 'ajo' && (
        <FieldLabel label='Surface ID'>
          <Textfield
            placeholder=''
            name='surfaceId'
            value={screen.meta.surfaceId || ''}
            onChange={onScreenUpdate('surfaceId')}
            disabled={disabled}
          />
        </FieldLabel>
      )}

      <FieldLabel label=''>
        <JsonViewer
          content={{ data: screen.content }}
          buttonLabel='Show Sample Offer'
          dialogTitle='Sample Offer Content'
          indent={2}
        />
      </FieldLabel>
    </>
  )
}

function getPersonalizationMethod(screen) {
  return screen.meta.parsonalizationMethod || (screen.meta.enableTargeting ? 'target' : 'none')
}

export default [
  { label: 'Events', content: Events },
  { label: 'Personalization', content: Personalization },
]
